import { buildAssetUrl, decodeBase64Utf8, } from '#pplx/frontend/apps/ask/canvas-shared/utils/assetContentUtils.js';
function buildTextContent({ content, url, }) {
    if (!content || url)
        return '';
    return decodeBase64Utf8(content);
}
function buildDownloadInfo({ filename, size, url, }) {
    const sizeMetadata = size == null ? {} : { size };
    if (url && !url.startsWith('data:'))
        return [{ filename, url, ...sizeMetadata }];
    return [];
}
/**
 * Build an Asset when the backend has already inferred the AssetType.
 * Unknown or unsupported non-text assets stay URL/download based so binary
 * content is not coerced into a UTF-8 CODE_FILE.
 */
export function buildAssetFromInferredType({ assetType, filename, mimeType, content, url, uuid, size, }) {
    const assetUrl = buildAssetUrl({ content, mimeType, url });
    const downloadInfo = buildDownloadInfo({ filename, size, url: assetUrl });
    const textContent = buildTextContent({ content, url });
    switch (assetType) {
        case 'CODE_FILE':
            return {
                uuid,
                asset_type: 'CODE_FILE',
                code_file: {
                    filename,
                    content: textContent,
                    ...(url ? { url: assetUrl, file_size: size } : {}),
                    mime_type: mimeType,
                },
                ...(downloadInfo.length > 0 ? { download_info: downloadInfo } : {}),
            };
        case 'GENERATED_IMAGE':
            return {
                uuid,
                asset_type: 'GENERATED_IMAGE',
                generated_image: { url: assetUrl },
                download_info: downloadInfo,
            };
        case 'GENERATED_VIDEO':
            return {
                uuid,
                asset_type: 'GENERATED_VIDEO',
                generated_video: { url: assetUrl },
                download_info: downloadInfo,
            };
        case 'PDF_FILE':
            return {
                uuid,
                asset_type: 'PDF_FILE',
                pdf_file: { url: assetUrl, filename, file_size: size },
                download_info: downloadInfo,
            };
        case 'DOCX_FILE':
            return {
                uuid,
                asset_type: 'DOCX_FILE',
                docx_file: { url: assetUrl, filename, file_size: size },
                download_info: downloadInfo,
            };
        case 'DOC_FILE':
            return {
                uuid,
                asset_type: 'DOC_FILE',
                doc_file: {
                    url: assetUrl,
                    filename,
                    file_size: size,
                    source_content: textContent,
                    final: true,
                },
                download_info: downloadInfo,
            };
        case 'RESEARCH_REPORT':
            return {
                uuid,
                asset_type: 'RESEARCH_REPORT',
                research_report: {
                    name: filename,
                    filename,
                    url: assetUrl,
                    source_content: textContent,
                    final: true,
                },
                download_info: downloadInfo,
            };
        case 'XLSX_FILE':
            return {
                uuid,
                asset_type: 'XLSX_FILE',
                xlsx_file: { url: assetUrl, filename, file_size: size },
                download_info: downloadInfo,
            };
        case 'SLIDES':
            return {
                uuid,
                asset_type: 'SLIDES',
                slide_file: { name: filename, url: assetUrl },
                app: { name: filename, filename, url: assetUrl, source_content: textContent, final: true },
                download_info: downloadInfo,
            };
        case 'AUDIO_FILE':
            return {
                uuid,
                asset_type: 'AUDIO_FILE',
                audio_file: { name: filename, url: assetUrl, filename, file_size: size },
                download_info: downloadInfo,
            };
        case 'MODEL_3D':
            return {
                uuid,
                asset_type: 'MODEL_3D',
                model_3d: {
                    name: filename,
                    url: assetUrl,
                    filename,
                    file_size: size,
                    mime_type: mimeType,
                },
                download_info: downloadInfo,
            };
        case 'APP':
            return {
                uuid,
                asset_type: 'APP',
                app: {
                    name: filename,
                    filename,
                    url: assetUrl,
                    app_url: assetUrl,
                    source_content: textContent,
                    final: true,
                },
                download_info: downloadInfo,
            };
        case 'CHART':
            return {
                uuid,
                asset_type: 'CHART',
                chart: { url: assetUrl, name: filename },
                download_info: downloadInfo,
            };
        case 'SCREENSHOT':
            return {
                uuid,
                asset_type: 'SCREENSHOT',
                screenshot: { url: assetUrl },
                download_info: downloadInfo,
            };
    }
    return {
        uuid,
        asset_type: 'UNKNOWN',
        fallback_info: { name: filename, webview_url: assetUrl },
        download_info: downloadInfo,
    };
}
//# sourceMappingURL=inferredAssetTypeUtils.js.map